<ion-header>
  <ion-toolbar class="preference-toolbar">
    <ion-buttons slot="start">
      <ion-button color="dark" (click)="handleBack()">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <ion-text>{{getTitle()}}</ion-text>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="preference-screen-container" *ngIf="viewMode === 'VIEW_MODE_SETTING'">
    <h3 class="title-main">Theme</h3>
    <div class="preference-screen-wrapper">
      <ion-item>
        <ion-label>Light/Dark</ion-label>
        <ion-toggle (ionChange)="handleChangeTheme($event)" [checked]="themeDark" slot="end"></ion-toggle>
      </ion-item>
    </div>
    <div *ngIf="!isProduction || isTestMode">
      <h3 class="title-main">Location</h3>
      <div class="preference-screen-wrapper">
        <ion-item>
          <ion-label>Location</ion-label>
          <ion-toggle (ionChange)="handleChangeLocation($event)" [checked]="locationCheck" slot="end"></ion-toggle>
        </ion-item>
        <ion-note color="medium">Note: This option is only available for testing purposes.</ion-note>
      </div>
    </div>

    <div class="delete-btn-container">
      <ion-button expand="block" color="danger" (click)="handleDelete()">Delete Account</ion-button>
    </div>
  </div>
  <form [formGroup]="accountForm" class="preference_delete" *ngIf="viewMode === 'VIEW_MODE_DELETE_FORM'">
    <h3 class="preference_delete-title">
      Are you sure you want to delete your account?
    </h3>
    <p class="preference_delete-desc">
      Please note that if you proceed, your account will be locked for the next
      six months. If you do not access your account during this time, it will be
      permanently deleted.<br /><br />

      Deleting your account means you will lose all your saved information,
      messages, and settings. This action cannot be undone.<br /><br />

      Are you sure you want to proceed with the account deletion?
    </p>
    <div class="preference_delete-form">
      <ion-item>
        <ion-input required type="email" placeholder="Email" label="Email" labelPlacement="floating"
          formControlName="email"></ion-input>
      </ion-item>
    </div>
    <div class="preference_delete-footer">
      <a class="link-btn" (click)="handleBack()">Cancel</a>
      <ion-button color="danger" (click)="handleDeleteAccount()" expand="block"
        [disabled]="accountForm.get('email').value != accountEmail">Delete</ion-button>
    </div>
  </form>
</ion-content>